



















































import { defineComponent, PropType, ref } from "@nuxtjs/composition-api"

import UserAvatar from "@/components/UserAvatar.vue"
import { User } from "@/types/models/User"

export default defineComponent({
  components: { UserAvatar },
  props: {
    professional: {
      type: Object as PropType<User>,
      required: true,
    },
    specialities: {
      type: String,
      required: true,
    },
    showNextCard: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const defaultProfessionalPhoto = require("~/assets/images/doc_pic.jpg")
    const professionalPhoto = ref()

    // const { isLoading } = useAvatarUserQuery(
    //   {
    //     userId: props.professional.id,
    //   },
    //   {
    //     onSuccess: (data) => {
    //       if (data.size > 0) {
    //         professionalPhoto.value = URL.createObjectURL(data)
    //       }
    //     },
    //     onError: () => {}, // not show toast error to the user if the avatar has an errorv
    //   },
    // )

    const location = () => {
      // TODO calc distance between professional and customer
      return ""
    }

    const openCase = () => {
      // TODO add the redirect
      // to what page? waiting answer
    }

    return {
      defaultProfessionalPhoto,
      professionalPhoto,
      location,
      openCase,
    }
  },
})
